import { render, staticRenderFns } from "./OverTimePlanAdd.vue?vue&type=template&id=23fbaed0&scoped=true&"
import script from "./OverTimePlanAdd.vue?vue&type=script&lang=js&"
export * from "./OverTimePlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fbaed0",
  null
  
)

export default component.exports